import { render, staticRenderFns } from "./Commentary.vue?vue&type=template&id=2e3690f0&scoped=true&"
import script from "./Commentary.vue?vue&type=script&lang=js&"
export * from "./Commentary.vue?vue&type=script&lang=js&"
import style0 from "./Commentary.vue?vue&type=style&index=0&id=2e3690f0&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3690f0",
  null
  
)

export default component.exports